import _ from 'lodash';
import { getLegs as getDeliveryLegs } from '../../libs/deliveryLegs';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import OcrIngestionResultsContainer from '../../containers/ocr/OcrIngestionResults';
import AuthUserContainer from '../../containers/AuthUser';
import clsx from 'classnames';

import { getSharedStyles } from '../../themes';
import EnhancedTable from '../../components/table/EnhancedTable';
import Button from '@material-ui/core/Button';
import { CircularProgress, Typography } from '@material-ui/core';
import OpenLink from '@material-ui/icons/OpenInNew';

import GreenChecked from '../../images/icons/greenChecked.svg';
import YellowWarning from '../../images/icons/yellowWarning.svg';
import ErrorIcon from '../../images/icons/error.svg';

import ResourcePopup from '../../components/Dialogs/ResourcePopup';
import invoiceIcon from '../../images/invoicePdf.svg';
import { renderOcrIngestionDocs } from './helper';

//Tabs
// import ProcessingIcon from '@material-ui/icons/Update';
import PendingIcon from '@material-ui/icons/AccessTime';
import InvalidIcon from '@material-ui/icons/DeleteForever';
import SentIcon from '@material-ui/icons/Send';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';

TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};

function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir}>
			{children}
		</Typography>
	);
}

const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	docContainer: {
		position: 'absolute',
	},
	addButton: {
		verticalAlign: 'middle',
		textDecoration: 'none',
		marginBottom: 10,
		borderRadius: 100,
	},
	greenCheckedIconSmall: {
		backgroundImage: `url('${GreenChecked}')`,
		display: 'inline-block',
		width: 16,
		height: 16,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	warningIconSmall: {
		backgroundImage: `url('${YellowWarning}')`,
		display: 'inline-block',
		width: 22,
		height: 22,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	errorIconSmall: {
		backgroundImage: `url('${ErrorIcon}')`,
		display: 'inline-block',
		width: 18,
		height: 18,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	invoiceIcon: {
		display: 'inline-block',
		width: 40,
		height: 48,
		backgroundImage: `url('${invoiceIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
});

const commonColumns = [
	{
		sortId: 'ocrIngestionResultId',
		displayId: 'allIds',
		label: 'Result ID',
	},
	{
		sortId: 'originalDocumentDisplay',
		displayId: 'originalDocumentDisplay',
		label: 'Uploaded Doc',
	},
	/*
	{
		sortId: 'dateCreated',
		displayId: 'dateCreatedFormatted',
		label: 'Date Created',
	},
	*/
	{
		sortId: 'documentInfo',
		displayId: 'documentsDisplay',
		label: 'Matched Documents',
	},
	{
		sortId: 'matchStationDeliveryStatus',
		displayId: 'matchStationDeliveryStatusDisplay',
		label: 'Delivery Match',
	},
	{
		sortId: 'matchStationInvoiceStatus',
		displayId: 'matchStationInvoiceStatusDisplay',
		label: 'Invoice/Rack Match',
	},
	{
		sortId: 'matchDataStatus',
		displayId: 'matchDataStatusDisplay',
		label: 'Data Match',
	},
];

/*
const processingColumns = [
	...commonColumns,
	{
		sortId: 'processingStatus',
		displayId: 'processingStatusDisplay',
		label: 'Status',
	},
];
*/

const triageColumns = [
	...commonColumns,
	{
		sortId: 'triage',
		displayId: 'triageButtons',
		label: 'Triage',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

const invoicedColumns = [
	...commonColumns,
	{
		sortId: 'view',
		displayId: 'viewButton',
		label: 'View',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

const invalidColumns = [
	...commonColumns,
	{
		sortId: 'invalidReason',
		displayId: 'invalidReason',
		label: 'Reason Invalid',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
	{
		sortId: 'view',
		displayId: 'viewButton',
		label: 'View',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

class OcrIngestionResults extends Component {
	constructor(props) {
		super(props);

		const startingTab = _.get(this.props, ['match', 'params', 'startingTab'], 'triage');
		const startingTabIndex = !_.isNil({ triage: 0, issued: 1, invalid: 2 }[startingTab])
			? { triage: 0, issued: 1, invalid: 2 }[startingTab]
			: 1;

		this.state = {
			tabIndex: startingTabIndex,
			order: 'desc',
			orderBy: 'ocrIngestionResultId',
			search: '',
			filterMap: {},
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],

			/*
			upcomingRows: undefined,
			currentRows: undefined,
			completedRows: undefined,
			*/
		};
	}

	componentDidMount() {
		const { ocrIngestionResults, ocrIngestionResultSearch } = this.props;

		if (!ocrIngestionResults) {
			ocrIngestionResultSearch({ doNotIncludeOcrBlocks: true });
		} else {
			this.formatOcrIngestionResults();
		}
	}

	componentDidUpdate(prevProps) {
		const { ocrIngestionResults } = this.props;
		if (prevProps.ocrIngestionResults !== ocrIngestionResults) {
			this.formatOcrIngestionResults();
		}
	}

	formatOcrIngestionResults = () => {
		const { classes } = this.props;
		const {
			ocrIngestionResults,
			ocrIngestionDocumentMap,
			stationInvoiceMap,
			ocrGuideMap,
		} = this.props;

		const triageRows = [];
		const invoicedRows = [];
		const invalidRows = [];
		//const processingRows = [];

		ocrIngestionResults.forEach((ocrIngestionResult) => {
			const {
				ocrIngestionResultId,
				ocrIngestionId,
				ocrIngestionDocumentIds,
				dateCreated,

				// station deliveries
				matchStationDeliveryStatus,
				matchedStationDeliveryId,
				matchStationInvoiceStatus,
				matchedStationInvoiceId,

				// rack transfers
				matchBulkDeliveryStatus,
				//matchBulkDeliveryStatusMessage,
				matchedBulkDeliveryId,
				matchRackTransferStatus,
				// matchRackTransferStatusMessage,
				matchedRackTransferId,

				matchDataStatus,
				ingestionStatus,
				originalIngestionDocumentResourceId,
				mappedToStationInvoiceId,
				mappedToRackTransferId,
				invalidReason,
				// processingStatus,
				// processingStatusMessage,
			} = ocrIngestionResult;

			ocrIngestionResult.key = ocrIngestionResultId;

			ocrIngestionResult.allIds = (
				<div>
					<div>Result Id: {ocrIngestionResultId}</div>
					<div>Ingestion Id: {ocrIngestionId}</div>
					<div>{moment(dateCreated).format('M/D/YYYY')}</div>
				</div>
			);

			if (ingestionStatus === 'complete') {
				ocrIngestionResult.ingestionStatusDisplay = 'Complete';
			} else {
				ocrIngestionResult.ingestionStatusDisplay = (
					<>
						<CircularProgress size="14px" style={{ marginRight: 4 }} />
						{_.startCase(ingestionStatus)}
					</>
				);
			}

			let invoiceRackDisplay = '-';
			let stationIdFromInvoice;

			const isRackMatch = matchRackTransferStatus ? true : false;
			const invoiceRackStatus = isRackMatch ? matchRackTransferStatus : matchStationInvoiceStatus;

			if (invoiceRackStatus === 'matched') {
				if (isRackMatch) {
					if (matchedRackTransferId) {
						invoiceRackDisplay = this.getRackTransferInfo({
							matchedRackTransferId,
							matchedBulkDeliveryId,
						});
					}
				} else {
					if (matchedStationInvoiceId) {
						const stationInvoice = stationInvoiceMap[matchedStationInvoiceId];
						stationIdFromInvoice = stationInvoice.stationId;
						invoiceRackDisplay = this.getStationInvoiceInfo({
							matchedStationInvoiceId,
							matchedStationDeliveryId,
						});
					}
				}

				ocrIngestionResult.matchStationInvoiceStatusDisplay = (
					<>
						<div>
							<span className={classes.greenCheckedIconSmall} /> Matched
						</div>
						{invoiceRackDisplay}
					</>
				);
			} else {
				ocrIngestionResult.matchStationInvoiceStatusDisplay = (
					<>
						<span className={classes.warningIconSmall} /> {_.startCase(invoiceRackStatus || 'None')}
					</>
				);
			}

			const deliveryStatus = matchBulkDeliveryStatus
				? matchBulkDeliveryStatus
				: matchStationDeliveryStatus;
			const isBulkMatch = matchBulkDeliveryStatus ? true : false;

			if (deliveryStatus === 'matched') {
				let deliveryInfo;
				if (isBulkMatch) {
					deliveryInfo = this.getBulkDeliveryInfo({
						bulkDeliveryId: matchedBulkDeliveryId,
					});
				} else {
					deliveryInfo = this.getDeliveryInfo({
						invoiceStationId: stationIdFromInvoice,
						stationDeliveryId: matchedStationDeliveryId,
					});
				}

				ocrIngestionResult.matchStationDeliveryStatusDisplay = (
					<>
						<div>
							<span className={classes.greenCheckedIconSmall} /> Matched
						</div>
						{deliveryInfo}
					</>
				);
			} else {
				ocrIngestionResult.matchStationDeliveryStatusDisplay = (
					<>
						<span className={classes.warningIconSmall} /> {_.startCase(deliveryStatus)}
					</>
				);
			}

			if (matchDataStatus === 'matched') {
				ocrIngestionResult.matchDataStatusDisplay = (
					<>
						<span className={classes.greenCheckedIconSmall} /> Matched
					</>
				);
			} else if (matchDataStatus === 'partialMatch') {
				ocrIngestionResult.matchDataStatusDisplay = (
					<>
						<span className={classes.warningIconSmall} /> {_.startCase(matchDataStatus)}
					</>
				);
			} else {
				ocrIngestionResult.matchDataStatusDisplay = (
					<>
						<span className={classes.errorIconSmall} /> {_.startCase(matchDataStatus)}
					</>
				);
			}

			// ocrIngestionResult.detectionIndicatorBlockCount = detectionIndicatorBlocks.length;
			// ocrIngestionResult.deliveryMatchingBlockCount = deliveryMatchingBlocks.length;
			// ocrIngestionResult.invoiceDataBlockCount = invoiceDataBlocks.length;

			ocrIngestionResult.originalDocumentDisplay = (
				<div
					className={classes.invoiceIcon}
					onClick={() => {
						this.handleDocClick(originalIngestionDocumentResourceId);
					}}
				/>
			);

			if (_.isEmpty(ocrIngestionDocumentIds)) {
				ocrIngestionResult.documentsDisplay = '-';
			} else {
				const ocrIngestionDocuments = ocrIngestionDocumentIds.map((ocrIngestionDocumentId) => {
					return ocrIngestionDocumentMap[ocrIngestionDocumentId];
				});

				ocrIngestionResult.documentsDisplay = renderOcrIngestionDocs({
					ocrIngestionDocuments,
					ocrGuideMap,
					ignoreGroups: true,
				});
			}

			ocrIngestionResult.triageButtons = (
				<Button className={classes.button} onClick={() => this.handleTriage(ocrIngestionResultId)}>
					Triage
				</Button>
			);

			ocrIngestionResult.viewButton = (
				<>
					<Button
						className={classes.button}
						onClick={() => this.handleTriage(ocrIngestionResultId)}
					>
						View
					</Button>
					{mappedToStationInvoiceId && (
						<div style={{ fontSize: 13 }}>
							<span style={{ color: 'green', display: 'inline-block', width: '15px' }}>✓</span>
							mapped
						</div>
					)}

					{mappedToRackTransferId && (
						<div style={{ fontSize: 13 }}>
							<span style={{ color: 'green', display: 'inline-block', width: '15px' }}>✓</span>
							mapped
						</div>
					)}
				</>
			);

			/*
			if (processingStatus !== 'complete' && processingStatus !== 'error') {
				ocrIngestionResult.processingStatusDisplay = (
					<>
						<div>{processingStatus}</div>
						<div>{processingStatusMessage}</div>
					</>
				);
				processingRows.push(ocrIngestionResult);
			} else if (invalidReason) {
				*/
			if (invalidReason) {
				invalidRows.push(ocrIngestionResult);
			} else if (mappedToStationInvoiceId || mappedToRackTransferId) {
				invoicedRows.push(ocrIngestionResult);
			} else {
				triageRows.push(ocrIngestionResult);
			}
		});
		//this.setState({ invalidRows, invoicedRows, triageRows, processingRows });
		this.setState({ invalidRows, invoicedRows, triageRows });
	};

	getStationInvoiceInfo = ({ matchedStationInvoiceId, matchedStationDeliveryId }) => {
		const { stationInvoiceMap, stationDeliveryMap } = this.props;
		const stationInvoice = stationInvoiceMap[matchedStationInvoiceId];
		if (!stationInvoice) {
			console.error(`Can not find stationInvoice`, matchedStationInvoiceId);
			return;
		}

		const stationDelivery = stationDeliveryMap[matchedStationDeliveryId];
		if (!stationDelivery) {
			console.error(`Can not find stationDeliveryId`, matchedStationDeliveryId);
			return;
		}

		const { deliveryWindowEndDateTime } = stationDelivery;
		const dateDisplay = moment(deliveryWindowEndDateTime).format('ddd, M/D');
		const invoiceInfo = (
			<>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
					}}
				>
					Station Invoice #<strong>{matchedStationInvoiceId}</strong>
					<a
						href={`/accounting/stationInvoice/update/${matchedStationInvoiceId}`}
						style={{ textDecoration: 'none', paddingLeft: 5, height: 17 }}
						target="_blank"
						rel="noreferrer noopener"
					>
						<OpenLink style={{ width: 16, height: 16 }} />
					</a>
				</div>
				<div>Date : {dateDisplay}</div>
			</>
		);
		return invoiceInfo;
	};

	getRackTransferInfo = ({ matchedRackTransferId, matchedBulkDeliveryId }) => {
		const { rackTransferMap, bulkCustomerMap, bulkDeliveryMap, terminalMap } = this.props;
		const rackTransfer = rackTransferMap[matchedRackTransferId];
		if (!rackTransfer) {
			console.error(`Can not find rackTransfer`, matchedRackTransferId);
			return;
		}

		const { pickupTerminalId, bulkCustomerId } = rackTransfer;

		const bulkCustomer = bulkCustomerMap[bulkCustomerId] || {
			name: 'MISSING BULK CUSTOMER',
		};
		const pickupTerminal = terminalMap[pickupTerminalId] || { name: 'MISSING TERMINAL' };

		const bulkDelivery = bulkDeliveryMap[matchedBulkDeliveryId];
		if (!bulkDelivery) {
			console.error(`Can not find bulkDeliveryId:`, matchedBulkDeliveryId);
			return;
		}

		const { deliveryDate } = bulkDelivery;
		//const carrier = carrierMap[carrierId] || { name: 'MISSING CARRIER' };
		const dateDisplay = moment(deliveryDate).format('ddd, M/D, YYYY');
		const rackTransferInfo = (
			<div
				style={{
					borderLeft: '2px solid #ddd',
					paddingLeft: 7,
				}}
			>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
					}}
				>
					Rack Transfer #<strong>{matchedRackTransferId}</strong>
					<a
						href={`/accounting/rackTransfer/update/${matchedRackTransferId}`}
						style={{ textDecoration: 'none', paddingTop: 5, paddingLeft: 5 }}
						target="_blank"
						rel="noreferrer noopener"
					>
						<OpenLink style={{ width: 18, height: 18 }} />
					</a>
				</div>
				<div>Pickup Terminal : {pickupTerminal.name}</div>
				<div>Delivery Customer : {bulkCustomer.name}</div>
				<div>Date : {dateDisplay}</div>
			</div>
		);
		return rackTransferInfo;
	};

	getDeliveryInfo({ invoiceStationId, stationDeliveryId }) {
		const { stationDeliveryMap, stationMap, carrierMap, classes } = this.props;

		const stationDelivery = stationDeliveryMap[stationDeliveryId];

		if (!stationDelivery) {
			return <div>Problem : Delivery Id: {stationDeliveryId} not found</div>;
		}

		const { carrierId } = stationDelivery;

		//const productTypeDisplay = valueToDisplay(productType);

		//- One entry per stop that belongs to the invoice's station
		const deliveries = getDeliveryLegs(stationDelivery)
			.filter((leg) => leg.stationId === invoiceStationId)
			.map((leg) => ({
				stationId: leg.stationId,
				amount: leg.deliveryAmount,
				productType: leg.productType,
			}));
		const carrier = carrierMap[carrierId] || { name: 'MISSING CARRIER' };
		return (
			<>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
					}}
				>
					Station Delivery #<strong>{stationDeliveryId}</strong>
					<a
						href={`/logistics/stationDelivery/update/${stationDeliveryId}`}
						style={{ textDecoration: 'none', paddingLeft: 5, height: 17 }}
						target="_blank"
						rel="noreferrer noopener"
					>
						<OpenLink style={{ width: 16, height: 16 }} />
					</a>
				</div>
				<div>{carrier.name}</div>

				{deliveries.map(({ stationId }, i) => {
					const station = stationMap[stationId] || { number: '', name: 'Missing station' };
					const destinationDisplay = `${station.number} - ${station.name}`;

					const deliveryClasses = [classes.deliverySection];
					if (i !== 0) {
						deliveryClasses.push(classes.deliveryBottom);
					}

					//- every entry here already belongs to the invoice's station
					deliveryClasses.push(classes.deliverySelected);
					return (
						<div className={clsx(deliveryClasses)} key={stationId}>
							<div>{destinationDisplay}</div>
						</div>
					);
				})}
			</>
		);
	}

	getBulkDeliveryInfo({ bulkDeliveryId }) {
		const { bulkDeliveryMap, carrierMap } = this.props;

		const bulkDelivery = bulkDeliveryMap[bulkDeliveryId];

		if (!bulkDelivery) {
			return <div>Problem : Bulk Delivery Id: {bulkDeliveryId} not found</div>;
		}

		const { carrierId } = bulkDelivery;
		const carrier = carrierMap[carrierId] || { name: 'MISSING CARRIER' };

		return (
			<>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
					}}
				>
					Bulk Delivery #<strong>{bulkDeliveryId}</strong>
					<a
						href={`/logistics/bulkDelivery/update/${bulkDeliveryId}`}
						style={{ textDecoration: 'none', paddingLeft: 5, height: 17 }}
						target="_blank"
						rel="noreferrer noopener"
					>
						<OpenLink style={{ width: 20, height: 20 }} />
					</a>
				</div>
				<div>Carrier : {carrier.name}</div>
			</>
		);
	}

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleTriage = (ocrIngestionResultId) => {
		this.props.history.push(`/ocr/ocrIngestionResult/triage/${ocrIngestionResultId}`);
	};

	handleDocClick = (resourceId) => {
		this.setState({
			resourceIdsPoppedUp: [resourceId],
			isResourcePopupOpen: true,
		});
	};

	handleCloseResourcePopup = () => {
		this.setState({
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
		});
	};

	handleTabChange = (event, tabIndex) => {
		this.setState({ tabIndex });
	};

	handleChangeTabIndex = (index) => {
		this.setState({ tabIndex: index });
	};

	render() {
		const { classes, resourceMap, theme } = this.props;
		const { triageRows, invalidRows, invoicedRows, order, orderBy } = this.state;

		if (!triageRows && !invoicedRows) {
			return <div>Loading the ocr ingestions...</div>;
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={8}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>OCR Ingestion Result Triage</span>
							</Typography>
						</Grid>
					</Grid>

					<AppBar position="static" color="default">
						<Tabs
							value={this.state.tabIndex}
							onChange={this.handleTabChange}
							indicatorColor="primary"
							textColor="primary"
							variant="fullWidth"
							centered
						>
							<Tab label="Pending Triage" icon={<PendingIcon />} />
							<Tab label="Invoice/Rack Issued" icon={<SentIcon />} />
							<Tab label="Invalid / Skipped" icon={<InvalidIcon />} />
						</Tabs>
					</AppBar>

					<Paper className={classes.paper}>
						<SwipeableViews
							axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
							index={this.state.tabIndex}
							onChangeIndex={this.handleChangeTabIndex}
						>
							{/*
							<TabContainer dir={theme.direction}>
								<EnhancedTable
									columns={processingColumns}
									rows={processingRows}
									defaultOrder={order}
									defaultOrderBy={orderBy}
								/>
							</TabContainer>
		*/}

							<TabContainer dir={theme.direction}>
								<EnhancedTable
									columns={triageColumns}
									rows={triageRows}
									defaultOrder={order}
									defaultOrderBy={orderBy}
								/>
							</TabContainer>

							<TabContainer dir={theme.direction}>
								<EnhancedTable
									columns={invoicedColumns}
									rows={invoicedRows}
									defaultOrder={order}
									defaultOrderBy={orderBy}
								/>
							</TabContainer>

							<TabContainer dir={theme.direction}>
								<EnhancedTable
									columns={invalidColumns}
									rows={invalidRows}
									defaultOrder={order}
									defaultOrderBy={orderBy}
								/>
							</TabContainer>

							<ResourcePopup
								open={this.state.isResourcePopupOpen}
								onClose={this.handleCloseResourcePopup}
								resourceIds={this.state.resourceIdsPoppedUp}
								resourceMap={resourceMap}
							/>
						</SwipeableViews>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

OcrIngestionResults.propTypes = {
	classes: PropTypes.object.isRequired,
	ocrIngestionResultSearch: PropTypes.func.isRequired,
	ocrIngestionResults: PropTypes.array,

	showErrors: PropTypes.func.isRequired,

	ocrIngestionDocumentMap: PropTypes.object,
	carrierMap: PropTypes.object,
	supplierMap: PropTypes.object,
	terminalMap: PropTypes.object,
	resourceMap: PropTypes.object,
	bulkCustomerMap: PropTypes.object,
	bulkDeliveryMap: PropTypes.object,
	stationInvoiceMap: PropTypes.object,
	stationDeliveryMap: PropTypes.object,
	rackTransferMap: PropTypes.object,
	stationMap: PropTypes.object,
	ocrGuideMap: PropTypes.object,

	history: PropTypes.object,
	theme: PropTypes.object.isRequired,

	authUser: PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	OcrIngestionResultsContainer,
])(OcrIngestionResults);
